// source: wisetime/account/user/v4/user.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var wisetime_type_site_ref_pb = require('../../../../wisetime/type/site_ref_pb.js');
goog.object.extend(proto, wisetime_type_site_ref_pb);
var wisetime_type_addons_pb = require('../../../../wisetime/type/addons_pb.js');
goog.object.extend(proto, wisetime_type_addons_pb);
var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var wisetime_type_data_retention_pb = require('../../../../wisetime/type/data_retention_pb.js');
goog.object.extend(proto, wisetime_type_data_retention_pb);
goog.exportSymbol('proto.wisetime.account.user.v4.User', null, global);
goog.exportSymbol('proto.wisetime.account.user.v4.WhoAmIRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.account.user.v4.WhoAmIRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.account.user.v4.WhoAmIRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.account.user.v4.WhoAmIRequest.displayName = 'proto.wisetime.account.user.v4.WhoAmIRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.account.user.v4.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.account.user.v4.User.repeatedFields_, null);
};
goog.inherits(proto.wisetime.account.user.v4.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.account.user.v4.User.displayName = 'proto.wisetime.account.user.v4.User';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.account.user.v4.WhoAmIRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.account.user.v4.WhoAmIRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.account.user.v4.WhoAmIRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.account.user.v4.WhoAmIRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.account.user.v4.WhoAmIRequest}
 */
proto.wisetime.account.user.v4.WhoAmIRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.account.user.v4.WhoAmIRequest;
  return proto.wisetime.account.user.v4.WhoAmIRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.account.user.v4.WhoAmIRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.account.user.v4.WhoAmIRequest}
 */
proto.wisetime.account.user.v4.WhoAmIRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.account.user.v4.WhoAmIRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.account.user.v4.WhoAmIRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.account.user.v4.WhoAmIRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.account.user.v4.WhoAmIRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.account.user.v4.User.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.account.user.v4.User.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.account.user.v4.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.account.user.v4.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.account.user.v4.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, ""),
    photoUrl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    countryCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    timezone: jspb.Message.getFieldWithDefault(msg, 8, ""),
    privateSite: (f = msg.getPrivateSite()) && wisetime_type_site_ref_pb.SiteRef.toObject(includeInstance, f),
    teamSitesList: jspb.Message.toObjectList(msg.getTeamSitesList(),
    wisetime_type_site_ref_pb.SiteRef.toObject, includeInstance),
    resolvedDataRetentionPeriod: jspb.Message.getFieldWithDefault(msg, 11, 0),
    maxRowsPerHour: jspb.Message.getFieldWithDefault(msg, 12, 0),
    serviceAddOns: (f = msg.getServiceAddOns()) && wisetime_type_addons_pb.ServiceAddOns.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.account.user.v4.User}
 */
proto.wisetime.account.user.v4.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.account.user.v4.User;
  return proto.wisetime.account.user.v4.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.account.user.v4.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.account.user.v4.User}
 */
proto.wisetime.account.user.v4.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhotoUrl(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 9:
      var value = new wisetime_type_site_ref_pb.SiteRef;
      reader.readMessage(value,wisetime_type_site_ref_pb.SiteRef.deserializeBinaryFromReader);
      msg.setPrivateSite(value);
      break;
    case 10:
      var value = new wisetime_type_site_ref_pb.SiteRef;
      reader.readMessage(value,wisetime_type_site_ref_pb.SiteRef.deserializeBinaryFromReader);
      msg.addTeamSites(value);
      break;
    case 11:
      var value = /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (reader.readEnum());
      msg.setResolvedDataRetentionPeriod(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxRowsPerHour(value);
      break;
    case 13:
      var value = new wisetime_type_addons_pb.ServiceAddOns;
      reader.readMessage(value,wisetime_type_addons_pb.ServiceAddOns.deserializeBinaryFromReader);
      msg.setServiceAddOns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.account.user.v4.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.account.user.v4.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.account.user.v4.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.account.user.v4.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPhotoUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPrivateSite();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      wisetime_type_site_ref_pb.SiteRef.serializeBinaryToWriter
    );
  }
  f = message.getTeamSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      wisetime_type_site_ref_pb.SiteRef.serializeBinaryToWriter
    );
  }
  f = message.getResolvedDataRetentionPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getServiceAddOns();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      wisetime_type_addons_pb.ServiceAddOns.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.account.user.v4.User.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string first_name = 2;
 * @return {string}
 */
proto.wisetime.account.user.v4.User.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string last_name = 3;
 * @return {string}
 */
proto.wisetime.account.user.v4.User.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 5;
 * @return {string}
 */
proto.wisetime.account.user.v4.User.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string photo_url = 6;
 * @return {string}
 */
proto.wisetime.account.user.v4.User.prototype.getPhotoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.setPhotoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string country_code = 7;
 * @return {string}
 */
proto.wisetime.account.user.v4.User.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string timezone = 8;
 * @return {string}
 */
proto.wisetime.account.user.v4.User.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional wisetime.type.SiteRef private_site = 9;
 * @return {?proto.wisetime.type.SiteRef}
 */
proto.wisetime.account.user.v4.User.prototype.getPrivateSite = function() {
  return /** @type{?proto.wisetime.type.SiteRef} */ (
    jspb.Message.getWrapperField(this, wisetime_type_site_ref_pb.SiteRef, 9));
};


/**
 * @param {?proto.wisetime.type.SiteRef|undefined} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
*/
proto.wisetime.account.user.v4.User.prototype.setPrivateSite = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.clearPrivateSite = function() {
  return this.setPrivateSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.account.user.v4.User.prototype.hasPrivateSite = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated wisetime.type.SiteRef team_sites = 10;
 * @return {!Array<!proto.wisetime.type.SiteRef>}
 */
proto.wisetime.account.user.v4.User.prototype.getTeamSitesList = function() {
  return /** @type{!Array<!proto.wisetime.type.SiteRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, wisetime_type_site_ref_pb.SiteRef, 10));
};


/**
 * @param {!Array<!proto.wisetime.type.SiteRef>} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
*/
proto.wisetime.account.user.v4.User.prototype.setTeamSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.wisetime.type.SiteRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.type.SiteRef}
 */
proto.wisetime.account.user.v4.User.prototype.addTeamSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.wisetime.type.SiteRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.clearTeamSitesList = function() {
  return this.setTeamSitesList([]);
};


/**
 * optional wisetime.type.DataRetentionPeriod resolved_data_retention_period = 11;
 * @return {!proto.wisetime.type.DataRetentionPeriod}
 */
proto.wisetime.account.user.v4.User.prototype.getResolvedDataRetentionPeriod = function() {
  return /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.wisetime.type.DataRetentionPeriod} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.setResolvedDataRetentionPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional uint32 max_rows_per_hour = 12;
 * @return {number}
 */
proto.wisetime.account.user.v4.User.prototype.getMaxRowsPerHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.setMaxRowsPerHour = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.clearMaxRowsPerHour = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.account.user.v4.User.prototype.hasMaxRowsPerHour = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional wisetime.type.ServiceAddOns service_add_ons = 13;
 * @return {?proto.wisetime.type.ServiceAddOns}
 */
proto.wisetime.account.user.v4.User.prototype.getServiceAddOns = function() {
  return /** @type{?proto.wisetime.type.ServiceAddOns} */ (
    jspb.Message.getWrapperField(this, wisetime_type_addons_pb.ServiceAddOns, 13));
};


/**
 * @param {?proto.wisetime.type.ServiceAddOns|undefined} value
 * @return {!proto.wisetime.account.user.v4.User} returns this
*/
proto.wisetime.account.user.v4.User.prototype.setServiceAddOns = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.account.user.v4.User} returns this
 */
proto.wisetime.account.user.v4.User.prototype.clearServiceAddOns = function() {
  return this.setServiceAddOns(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.account.user.v4.User.prototype.hasServiceAddOns = function() {
  return jspb.Message.getField(this, 13) != null;
};


goog.object.extend(exports, proto.wisetime.account.user.v4);
